import type { IFormStep } from '../shared/interfaces/form-step.interface';
import type { IMachineProperty } from '../shared/interfaces/machine-property.interface';

export const APP_MACHINE_STEPS: IFormStep[] = [
    {
        id: 1,
        icon: 'agriculture',
        name: 'basic-info',
        link: 'basic-info',
        title: 'step_title_machine_basic_info',
        form: [
            {
                title: 'form_group_title_add_details_to_you_new_machine',
                items: [],
                sub: [],
            },
        ],
        valid: false,
        active: false,
        loading: false,
        disabled: false,
    },
    {
        id: 2,
        icon: 'build_circle',
        name: 'implements',
        link: 'implements',
        title: 'step_title_machine_implements',
        form: [],
        valid: true,
        active: false,
        loading: false,
        disabled: false,
    },
    {
        id: 3,
        icon: 'check_circle_outline_filled',
        name: 'review-and-confirm',
        link: 'review-and-confirm',
        title: 'step_title_machine_review_and_confirm',
        form: [],
        valid: true,
        active: false,
        loading: false,
        disabled: true,
    },
];

export const APP_IMPLEMENTS_STEPS: IFormStep[] = [
    {
        id: 1,
        icon: 'build_circle',
        name: 'basic-info',
        link: 'basic-info',
        title: 'step_title_implement_basic_info',
        form: [
            {
                title: 'form_group_title_create_a_new_implement',
                items: [],
                sub: [],
            },
        ],
        valid: false,
        active: false,
        loading: false,
        disabled: false,
    },
    {
        id: 2,
        icon: 'agriculture',
        name: 'machines',
        link: 'machines',
        title: 'step_title_implement_machines',
        form: [],
        valid: true,
        active: false,
        loading: false,
        disabled: false,
    },
    {
        id: 3,
        icon: 'check_circle_outline_filled',
        name: 'review-and-confirm',
        link: 'review-and-confirm',
        title: 'step_title_implement_review_and_confirm',
        form: [],
        valid: true,
        active: false,
        loading: false,
        disabled: false,
    },
];

export const APP_IMPLEMENTS_ITMES: string[] = ['core.category'];

export const DISABLED_PROPERTIES = ['icon'];

export const APP_IMPLEMENT_RADIO_GROUP: IMachineProperty = {
    name: 'mount.active_field',
    tag: 'MACHINE',
    data_type: 'RADIO',
    is_required: true,
    id: '',
    default_value: 'specs.mount.is_drawbar',
    constraints: [
        {
            in: [
                {
                    title: 'Drawbar',
                    value: 'specs.mount.is_drawbar',
                },
                {
                    title: 'Loader Mounting Style',
                    value: 'specs.mount.loader_mounting_style',
                },
                {
                    title: 'Rear Hitch Category',
                    value: 'specs.mount.3pt_type',
                },
            ],
        },
    ],
    detail: '',
    label: {
        group: 'Mount',
        text: 'Choose one to determines the mount type',
    },
};

export const MACHINE_PROPERTY_ITEMS_ORDER = [
    'hydraulics.front.num_circuits',
    'hydraulics.front.min_flow_rate',
    'hydraulics.front.max_flow_rate',
    'hydraulics.front.max_pressure',
    'hydraulics.rear.num_circuits',
    'hydraulics.rear.min_flow_rate',
    'hydraulics.rear.max_flow_rate',
    'hydraulics.rear.max_pressure',
];
